import React, { useState, useContext, useEffect } from "react";

import { ModalContainer, LogsContainer, Log, HeaderLog, CardHomeContentLabelText, CardHomeContentLabel, CardHomeContentLabelDecoration } from "./styled";

import { CoreContext } from "context/CoreContext";
import { ReadByCampaignId } from "services/logs";
import { format } from "date-fns";

export default function ModalCampaignStatusLogs() {
  const { modal, setModal, user } = useContext(CoreContext);
  const [logs, setLogs] = useState([]);

  const close = () => {
    setModal(null);
  };

  const fetchLogs = async () => {
    const logs = await ReadByCampaignId(modal?.item?.campaign?.id);

    if (logs.error) {
      return;
    }

    setLogs(logs.data);
  }

  useEffect(() => {
    fetchLogs();
  }, []);

  return (
    <>
      <ModalContainer>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "12px",
            width: "480px",
            height: "fit-content",
            background: "rgba(255, 255, 255, 1)",
            borderRadius: "8px",
            padding: "16px",
          }}
        >
          <img
            src="/icons/close.svg"
            width={"10px"}
            height={"10px"}
            style={{ alignSelf: "end", cursor: "pointer" }}
            onClick={close}
          />

          <p style={{ margin: 0 }}>
            Histórico da campanha {modal?.item?.campaign?.title}
          </p>

          <LogsContainer>
            <LogComponent name={modal?.item?.campaign?.user?.name} label="Criada" createdAt={modal?.item?.campaign?.createdAt} />

            {logs?.map(log => (
              <LogComponent name={log.attributes.user.data?.attributes.name} label={log.attributes.data.label} createdAt={log.attributes.createdAt} />
            ))}

          </LogsContainer>
        </div>
      </ModalContainer>
    </>
  );
}

const LogComponent = ({ name, label, createdAt }) => {

  return <Log>
    <HeaderLog>

      <p style={{ margin: 0 }}>
        Por: <b>{name}</b>
      </p>

      <CardHomeContentLabel isSuccess={label === "Finalizada" || label === "Criada"}>
        <CardHomeContentLabelDecoration
          isSuccess={label === "Finalizada" || label === "Criada"} />

        <CardHomeContentLabelText isSuccess={label === "Finalizada" || label === "Criada"}>
          {label === "Andamento" ? "Reiniciada" : label}
        </CardHomeContentLabelText>
      </CardHomeContentLabel>


    </HeaderLog>
    <p style={{ marginRight: 2, alignSelf: "end", fontWeight: 500 }}>
      {format(createdAt, 'dd/MM/yyyy')}
    </p>
  </Log>
}


